class Helper {
    static convertToDateString = (timestamp) => {
        const date = new Date(timestamp);
        return date.toLocaleDateString();
    }

    static findLatestTimestamp = (timestamps) => {
        // Convert each timestamp to a date object and find the latest date
        const latestDate = new Date(Math.max(...timestamps.map(timestamp => new Date(timestamp))));

        return latestDate;
    }

    static isOverAMonthOld = (timestamp) => {
        const currentDate = new Date();
        const oneMonthAgo = new Date();

        // Subtract one month from the current date
        oneMonthAgo.setMonth(currentDate.getMonth() - 1);

        // Create a date object from the timestamp
        const compareDate = new Date(timestamp);

        // Compare if the timestamp's date is before the date one month ago
        return compareDate < oneMonthAgo;
    }

}

export default Helper;